import fs from 'fs';
import path from 'path';
import matter from 'gray-matter';
import { NextPageWithLayout } from './_app';
import Layout from 'components/Layout';
import TextPage from 'components/TextPage';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';
import { GetServerSideProps } from 'next';

interface IFaqProps {
  content: string | null;
  frontmatter: { title: string };
}

const Faq: NextPageWithLayout<IFaqProps> = ({
  frontmatter: { title },
  content,
}) => {
  return <TextPage title={title} content={content} />;
};

Faq.getLayout = (page: React.ReactElement) => (
  <Layout
    navBarClassName="bg-white py-6"
    titleProduction="meta_title_faq"
    titleStaging="Facts and questions"
    metaDescriptionProd="meta_description_production_faq"
    metaDescriptionStaging="Allmyles API showcase customers asked about these features"
    canonicalProd="https://tipptour.com/faq"
    canonicalStaging="https://showcase.allmyles.com/faq">
    {page}
  </Layout>
);
export default Faq;

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  const env = process.env.NEXTJS_NODE_ENV === 'production' ? 'prod' : 'dev';
  try {
    const markdownWithMeta = fs.readFileSync(
      path.join(process.cwd(), `assets/localization/faq/${env}/${locale}.md`),
    );
    const { data: frontmatter, content } = matter(markdownWithMeta);
    return {
      props: {
        ...(await serverSideTranslations(locale || 'en')),
        frontmatter: JSON.parse(JSON.stringify(frontmatter)),
        content: content,
      } as IFaqProps,
    };
  } catch (err) {
    return {
      props: {
        ...(await serverSideTranslations(locale || 'en')),
        frontmatter: { title: '' },
        content: null,
      } as IFaqProps,
    };
  }
};
